/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';

import Modal from '../../components/Modal';
import Maintenance from '../../components/Maintenance';
import { closeModal } from '../../../../lib/closeModal';

class MaintenanceModal extends React.Component {
  render() {
    const { history } = this.props;
    const maintenance = this.props.requests.maintenance.value;

    if (!maintenance) return null;

    const back = (e) => {
      e.stopPropagation();
      closeModal(history);
    };

    return (
      <Modal onClose={back} >
        <Maintenance
          maintenance={maintenance}
          missingTranslation={() => {}}
        />
      </Modal>
    );
  }
}

export default MaintenanceModal;
